import { supabase } from "./supabase";
export async function verbeterApi(
  query = "",
  body?: Record<string, unknown>,
  method = "POST",
) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const r = await fetch("/api/agent/verbeterpunten" + query, {
    method: body ? method : "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session?.access_token || ""}`,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.error || "Verzoek mislukt");
  return data;
}
